'use client'

import { MapPinIcon, TextButton, Typography } from '@/shared/ui/atoms'
import NaverMap from '@/shared/ui/organisms/NaverMap'
import { toast } from '@/shared/utils/toastMessage'
import { useState } from 'react'
import { HospitalMapViewerModal } from '@/widgets/hospital/ui/molecules'
import { useTranslations } from 'next-intl'
interface HospitailLocationProps {
  location: {
    latitude: number
    longitude: number
    address?: string
    parkingGuide?: string
  }
  /**
   * 새 상세 페이지의 섹션 셸 안에 들어갈 때. 제목과 바깥 여백은 섹션이 갖고 있으므로
   * 여기서는 내용만 그린다. 기본값(false)은 기존 상세 페이지의 모습 그대로다.
   */
  embedded?: boolean
}

const HospitailLocation = ({ location, embedded = false }: HospitailLocationProps) => {
  const t = useTranslations()
  const { address, parkingGuide, latitude, longitude } = location
  const [isMapOpen, setIsMapOpen] = useState(false)

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(address || "")
    toast.success(t("common.copySuccess"))
  }

  return (
    <div id={embedded ? undefined : "hospital-location"} className={embedded ? "" : "px-4 pb-[30px]"}>
      {embedded ? null : (
        <Typography size={18} className="py-3 text-gray-900 font-bold">
          {t("location.title")}
        </Typography>
      )}
      {address && <div className="flex items-start">
        <MapPinIcon size={16} className="text-gray-300 flex-shrink-0 mr-2" />
        <Typography size={14} lineHeight={18} className="text-gray-700">
          {address}
        </Typography>
        <TextButton text={t("common.copy")} size={12} className="mr-2 flex-shrink-0 text-gray-500 leading-[18px] underline decoration-gray-500 underline-offset-[3px]" onClick={handleCopyAddress} />
      </div>}
      <div className="w-full h-[120px] mt-2.5 mb-4">
        <div className="relative w-full h-full">
          <NaverMap location={{ latitude, longitude }} width="100%" height="120px" className="rounded-lg" />
          <button
            type="button"
            aria-label={t("common.openMapViewer")}
            className="absolute inset-0"
            onClick={() => setIsMapOpen(true)}
          />
        </div>
      </div>
      {parkingGuide && <div>
        <Typography size={16} className="py-2 text-gray-800 font-semibold">
          {t("location.parkingGuide")}
        </Typography>
        <Typography size={14} lineHeight={21} className="text-gray-800 break-keep">
          {parkingGuide}
        </Typography>
      </div>}

      <HospitalMapViewerModal
        open={isMapOpen}
        onClose={() => setIsMapOpen(false)}
        location={{ latitude, longitude }}
      />
    </div>
  )
}

export default HospitailLocation